import { createClient, UnpagedSearchOperation, unpagedSearchRequestFactory } from '@infuse/api/common';

import { BasicAuthDeviation } from './model';

const client = createClient('/api/basic-auth-deviations');

export const basicAuthDeviationPermissions = {
  GET_ALL: 'econnector.get-all-basic-auth-deviations'
};

export const getAllBasicAuthDeviations: UnpagedSearchOperation<BasicAuthDeviation[]> = unpagedSearchRequestFactory<
  BasicAuthDeviation[]
>(client, { permissionId: basicAuthDeviationPermissions.GET_ALL });
